import React from "react";
import "./french.scss";
import notvisited from "../../../assets/icons/not-visited.png";
import notanswered from "../../../assets/icons/not-answered.png";
import answered from "../../../assets/icons/answered.png";
import notanswerreview from "../../../assets/icons/not-answered-review.png";
import answerreview from "../../../assets/icons/answered-review.png";

const FrenchInstruction = (props) => {
  return (
    <>
      <div className="col-md-12 test-instructions">
        <p className="msgTitle">Instructions du test</p>
        <div>{props.instruction}</div>
        <div className="col-md-12 general-instructions">
          <p className="msgTitle">Instructions générales</p>
          <section>
            <ol>
              <li className="msgFont">
                L'horloge sera réglée sur le serveur. Le minuteur de compte à rebours dans le
                coin supérieur droit de l'écran affichera le temps restant
                disponible pour terminer l'examen. Lorsque le minuteur
                atteint zéro, l'examen se terminera automatiquement. Vous n'aurez pas
                besoin de terminer ou de soumettre votre examen.
              </li>
              <li className="msgFont">
                La palette de questions affichée sur le côté droit de l'écran affichera
                le statut de chaque question en utilisant l'un des symboles suivants :
                <ul className="legends-listing" type="none">
                  <li className="msgFont">
                    <img src={notvisited} /> Vous n'avez pas encore visité la question.
                  </li>
                  <li className="msgFont">
                    <img src={notanswered} /> Vous n'avez pas répondu à la question.
                  </li>
                  <li className="msgFont">
                    <img src={answered} /> Vous avez répondu à la question.
                  </li>
                  <li className="msgFont">
                    <img src={notanswerreview} /> Vous n'avez PAS répondu à la
                    question, mais avez marqué la question pour révision.
                  </li>
                  <li className="msgFont">
                    <img src={answerreview} /> La/les question(s) "Répondue et
                    Marquée pour révision" sera/seront considérée(s) pour l'évaluation.
                  </li>
                </ul>
              </li>
              <li className="msgFont">
                Le statut Marqué pour révision d'une question indique simplement
                que vous aimeriez regarder cette question à nouveau. Si une
                question est répondue et Marquée pour révision, votre réponse à cette
                question sera considérée dans l'évaluation.
              </li>
              <li className="msgFont">
                Vous pouvez cliquer sur la flèche qui apparaît à gauche de la
                palette de questions pour réduire la palette de questions, maximisant ainsi la
                fenêtre de question. Pour voir à nouveau la palette de questions, vous pouvez
                cliquer sur celle qui apparaît sur le côté droit de la fenêtre de question.
              </li>
              <li className="msgFont">
                Vous pouvez cliquer sur votre image "Profil" dans le coin supérieur droit de
                votre écran pour changer la langue pendant l'examen pour l'ensemble du
                questionnaire. En cliquant sur l'image Profil, vous obtiendrez un
                menu déroulant pour changer le contenu de la question vers la langue
                désirée.
              </li>
              <li className="msgFont">
                Vous pouvez cliquer sur Faire défiler vers le bas pour naviguer vers le bas et
                Faire défiler vers le haut pour naviguer vers le haut de la zone de question, sans
                faire défiler.
              </li>
            </ol>
          </section>

          <section>
            <p className="msgFont">
              <b>Naviguer vers une question</b>
            </p>
            <ol start="7">
              <li className="msgFont">
                Pour répondre à une question, procédez comme suit :
                <ol type="a">
                  <li className="msgFont">
                    Cliquez sur le numéro de question dans la palette de questions à
                    droite de votre écran pour aller directement à cette question numérotée.
                    Notez que cette option NE sauvegarde PAS votre
                    réponse à la question actuelle.
                  </li>
                  <li className="msgFont">
                    Cliquez sur Sauvegarder & Suivant pour sauvegarder votre réponse à la question
                    actuelle et passer à la question suivante.
                  </li>
                  <li className="msgFont">
                    Cliquez sur Marquer pour révision & Suivant pour sauvegarder votre réponse à la
                    question actuelle, la marquer pour révision, puis passer à la
                    question suivante.
                  </li>
                </ol>
              </li>
            </ol>
          </section>

          <section>
            <p className="msgFont">
              <b>Répondre à une question</b>
            </p>
            <ol start="8">
              <li className="msgFont">
                Procédure pour répondre à une question à choix multiple :
                <ol type="a">
                  <li className="msgFont">
                    Pour sélectionner votre réponse, cliquez sur le bouton d'une des
                    options.
                  </li>
                  <li className="msgFont">
                    Pour désélectionner votre réponse choisie, cliquez sur le bouton de l'
                    option choisie à nouveau ou cliquez sur le bouton Effacer la réponse.
                  </li>
                  <li className="msgFont">
                    Pour changer votre réponse choisie, cliquez sur le bouton d'une autre
                    option.
                  </li>

                  <li className="msgFont">
                    Pour sauvegarder votre réponse, vous DEVEZ cliquer sur le bouton
                    Sauvegarder & Suivant.
                  </li>
                  <li className="msgFont">
                    Pour marquer la question pour révision, cliquez sur le bouton
                    Marquer pour révision & Suivant. Si une réponse est sélectionnée pour une
                    question qui est Marquée pour révision, cette réponse sera
                    considérée dans l'évaluation.
                  </li>
                </ol>
              </li>
              <li className="msgFont">
                Pour changer votre réponse à une question qui a déjà été
                répondue, sélectionnez d'abord cette question pour y répondre puis
                suivez la procédure pour répondre à ce type de question.
              </li>
              <li className="msgFont">
                Notez que SEULES les questions pour lesquelles les réponses sont sauvegardées ou marquées
                pour révision après avoir répondu seront considérées pour l'évaluation.
              </li>
            </ol>
          </section>

          <section>
            <p className="msgFont">
              <b>Naviguer entre les sections</b>
            </p>
            <ol start="11">
              <li className="msgFont">
                Les sections de ce questionnaire sont affichées sur la barre supérieure de
                l'écran. Les questions d'une section peuvent être visualisées en cliquant sur le
                nom de la section. La section que vous visualisez actuellement est
                mise en évidence.
              </li>
              <li className="msgFont">
                Après avoir cliqué sur le bouton Sauvegarder & Suivant sur la dernière question d'une
                section, vous serez automatiquement dirigé vers la première question
                de la section suivante.
              </li>
              <li className="msgFont">
                Vous pouvez naviguer entre les sections et les questions à tout moment pendant
                l'examen selon votre convenance uniquement pendant le temps
                stipulé.
              </li>
              <li className="msgFont">
                Le candidat peut voir le résumé de la section correspondante dans le cadre de
                la légende qui apparaît dans chaque section au-dessus de la
                palette de questions.
              </li>
            </ol>
          </section>
        </div>
      </div>
    </>
  );
};

export default FrenchInstruction;